export default __webpack_public_path__ + "static/port-1-76191359d04e8bcfa8f62094cc4dd651.jpeg";